import { SupplierManagementPanel } from '../settings/suppliers';

export function SuppliersTab() {
  return <SupplierManagementPanel surface="inventory" />;
}
